import { format } from '../utils/Currency';


/**
 * This mixin can be used to format some value 
 * to system default currency format 
 */
export default {  

	mounted() {
		
		if(!this.defaultCurrency.id) {
			this.getDefaultCurrency();
		}
	},
  
	computed: {
		
		defaultCurrency() {
			return this.$store.getters.CURRENCY;
		}
	},

	methods: {
		
		formatValue(value, currency = this.defaultCurrency) {
			return format(value, currency);
		},

		async getDefaultCurrency() {
			await this.$store.dispatch('GET_SESSION_CURRENCY');
		},
		
	}
}